export const HERO_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/d4b45411-9387-4770-bdce-b5fbf5715a2f.jpg'
export const SARASWATI_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/8b7516c6-94ea-46a2-a009-14c0bdcf1b73.jpg'
export const WATER_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/cb5930ba-d302-4c57-981b-cf526b06f7cb.jpg'
export const FIRE_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/793b6097-5ca3-4bb1-99b8-d104e654cdb5.jpg'
export const EARTH_AIR_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/1bd6a3a2-4970-4a87-8cdd-ad76094b0058.jpg'

export const RESERVA_LINK =
  'https://wa.me/34682575310?text=Quiero%20informaci%C3%B3n%20sobre%20el%20retiro%20a%20Bali'

export interface Elemento {
  emoji: string
  numero: string
  nombre: string
  titulo: string
  puntos: { titulo: string; texto: string }[]
  cita: string
  imagen: string
  acento: string // css color var
}

export const ELEMENTOS: Elemento[] = [
  {
    emoji: '🌊',
    numero: 'El Primer Elemento',
    nombre: 'El Agua',
    titulo: 'Limpieza y Purificación Profunda',
    puntos: [
      {
        titulo: 'Ritual de Purificación',
        texto:
          'Sumérgete en aguas sagradas que han bendecido almas durante siglos. El agua disuelve lo que ya no eres.',
      },
      {
        titulo: 'Cascadas y Manantiales',
        texto:
          'Las aguas vivas de Bali limpian cuerpo, mente y espíritu en una experiencia que no tiene palabras.',
      },
      {
        titulo: 'Renacer',
        texto:
          'Siente cómo el agua disuelve tus bloqueos más profundos y despierta tu esencia más luminosa.',
      },
    ],
    cita: 'El agua disuelve lo que ya no eres.',
    imagen: WATER_IMG,
    acento: 'var(--blugreen)',
  },
  {
    emoji: '🔥',
    numero: 'El Segundo Elemento',
    nombre: 'El Fuego',
    titulo: 'Transformación y Renacimiento Interior',
    puntos: [
      {
        titulo: 'Ceremonia del Fuego',
        texto:
          'Una de las experiencias más catárticas y poderosas del retiro. Frente a las llamas sagradas, encenderás el fuego ígneo que vive dentro de ti — ese poder, esa pasión, esa fuerza que nunca debió apagarse.',
      },
      {
        titulo: 'Purificar, no destruir',
        texto:
          'El fuego no destruye: purifica, renueva y libera. Sal de la ceremonia reconociendo la libertad en ti.',
      },
    ],
    cita: 'El fuego sagrado es símbolo de poder, pasión y renovación interior absoluta.',
    imagen: FIRE_IMG,
    acento: 'var(--darkgoldenrod)',
  },
  {
    emoji: '🌬🌱',
    numero: 'Tercer y Cuarto Elemento',
    nombre: 'El Aire y la Tierra',
    titulo: 'Conexión y Equilibrio Profundo',
    puntos: [
      {
        titulo: 'El Aire',
        texto:
          'Prácticas de respiración consciente para liberar tensiones acumuladas, abrir el corazón y expandir tu campo energético.',
      },
      {
        titulo: 'La Tierra',
        texto:
          'Caminatas meditativas entre arrozales y bosques sagrados que nutren tu alma y anclan tu poder en el aquí y ahora. Yoga, movimiento y nutrición.',
      },
      {
        titulo: 'El Equilibrio',
        texto:
          'Siente la fuerza de los 4 elementos bajo tus pies y la frecuencia que renueva tu ser, en perfecta armonía con la vida.',
      },
    ],
    cita: 'Siente la fuerza de los 4 elementos bajo tus pies.',
    imagen: EARTH_AIR_IMG,
    acento: 'var(--glossygrape)',
  },
]

export const TRANSMUTACION: string[] = [
  'Talleres guiados para precipitar y elevar tu vibración y frecuencia, vivir con menos esfuerzo y más armonía.',
  'Recordar tu magia oculta y reconocer los frutos de tu sabiduría interior.',
  'Activar tu energía sexual magnética para una vida plena, creativa y poderosa.',
  'Permitir que la Diosa que eres reciba y reconozca su propia divinidad.',
]

export interface Testimonio {
  texto: string
  autor: string
}

export const TESTIMONIOS: Testimonio[] = [
  {
    texto:
      'En los viajes con Espacio para el Alma he logrado reconocerme. Es una experiencia que cambia la manera en que te ves y te amas.',
    autor: 'Sandra R.',
  },
  {
    texto:
      'La ceremonia del fuego que hace Pao me liberó de años de dolor y me dio la fuerza que necesitaba para avanzar con poder.',
    autor: 'Diana',
  },
  {
    texto:
      'Saber que a sus facilitadoras los elementos y la naturaleza les hablan, me sanó de una forma que nunca imaginé posible.',
    autor: 'Laura G.',
  },
]

export interface Detalle {
  emoji: string
  aspecto: string
  detalle: string
}

export const DETALLES: Detalle[] = [
  { emoji: '📅', aspecto: 'Fechas', detalle: '10 — 17 de octubre de 2026' },
  {
    emoji: '✈️',
    aspecto: 'Punto de encuentro',
    detalle: 'Aeropuerto Internacional de Denpasar, Bali',
  },
  {
    emoji: '🏡',
    aspecto: 'Alojamiento',
    detalle:
      'Villa Exclusiva 5★ — Alojamiento de lujo en villa privada con todo incluido',
  },
  {
    emoji: '🛕',
    aspecto: 'Ceremonias y Templos',
    detalle:
      'Rituales sagrados, visitas a templos ancestrales y experiencias únicas',
  },
  {
    emoji: '🍽',
    aspecto: 'Alimentación',
    detalle:
      'Desayuno y cena — Nutrición consciente incluida todos los días del retiro',
  },
  {
    emoji: '💻',
    aspecto: '4 Encuentros Previos',
    detalle: 'Sesiones de preparación por Zoom antes del viaje',
  },
]

export interface Facilitadora {
  nombre: string
  rol: string
  emoji: string
  cita: string
  parrafos: string[]
  lista?: { titulo: string; items: string[] }
  acento: string
}

export const FACILITADORAS: Facilitadora[] = [
  {
    nombre: 'Saraswasti',
    rol: 'La Vibración Original',
    emoji: '🎶',
    cita: 'La sabiduría los está buscando a ustedes. Solo deben quedarse lo suficientemente quietos para dejar que los alcance.',
    parrafos: [
      'Saraswati no es solo una deidad; es la vibración original, el Nada Brahma (el universo es sonido), la inteligencia cósmica que habita en el éter y en el centro exacto de sus corazones.',
      'Han llegado hasta aquí no por casualidad, sino por resonancia. Sus almas han pedido afinación, y el Universo ha respondido.',
      'Visualicen por un momento la Veena, el instrumento sagrado de cuerdas. Al igual que ella, sus cuerpos físicos y sutiles son cajas de resonancia cósmica. Durante nuestro tiempo juntos afinaremos esas cuerdas en la frecuencia adecuada.',
      'A mi lado siempre viaja el cisne blanco, el Hamsa, símbolo del Discernimiento (Viveka): capaz de beber solo la leche y dejar el agua intacta.',
    ],
    lista: {
      titulo: 'Tres portales de sabiduría',
      items: [
        'El Portal del Agua — Purificación',
        'El Portal del Sonido — Vibración',
        'El Portal del Loto — Silencio',
      ],
    },
    acento: 'var(--glossygrape)',
  },
  {
    nombre: 'Mónica Armel',
    rol: 'El Camino al Corazón',
    emoji: '🧘',
    cita: 'El gran maestro es el camino al Corazón. Esto me ha invitado a crear mis propios métodos para que tu cuerpo, mente y sentimientos encarnen el amor.',
    parrafos: [
      'He encontrado en mis múltiples formaciones con grandes maestros alrededor del mundo, y en la profundidad de la búsqueda de mi interior, que el gran maestro es el camino al Corazón.',
    ],
    lista: {
      titulo: 'Formación y certificaciones',
      items: [
        '🧘 Instructora de Yoga · Linaje Sivananda',
        '🌸 Yoga Tántrico · Certificada por Amrita Choudhury, Montreal',
        '💃 Yoga Danza · Arizona',
        '🎨 Terapia con el Arte · Artista Plástica',
        '🕊 Certificación en Duelo y Muerte · Psicología Transpersonal, España',
        '☮ Embassy of Peace · Jasmuheen',
      ],
    },
    acento: 'var(--blugreen)',
  },
  {
    nombre: 'Paola Carvajal',
    rol: 'Tejedora de Conciencia',
    emoji: '🔮',
    cita: 'Te invito a descubrirte, a ser rebelde y a vivir plenamente en armonía con el propósito de tu alma y la guía de tu corazón.',
    parrafos: [
      'Tejedora de Conciencia. Entrelazo sabidurías ancestrales con poderosas herramientas contemporáneas. Te acompaño a conectar lo divino y lo terrenal, facilitando espacios sagrados donde la alquimia, la prosperidad, la salud y el amor se vuelven posibles para todos.',
      'Creadora de Espacio para el Alma y mamá de tres.',
    ],
    lista: {
      titulo: 'Trayectoria y certificaciones',
      items: [
        '📚 17.000 almas impactadas',
        '📖 1 libro publicado en Colombia y España',
        '🌍 22 viajes a centros energéticos del planeta',
        '🌀 Maestra en geometría sagrada y flor de la vida',
        '🔮 Reality Transurfing Coach',
        '🌀 Metagenealogía y Tarot Evolutivo · Escuela Jodorowsky',
        '🌿 Sanadora pránica · Metafísica · Coach de vida',
      ],
    },
    acento: 'var(--satinsheengold)',
  },
]

export interface Precio {
  emoji: string
  concepto: string
  valor: string
  destacado?: boolean
}

export const PRECIOS: Precio[] = [
  { emoji: '💰', concepto: 'Inversión regular', valor: '3.500 USD' },
  { emoji: '✈️', concepto: 'Viajeros del Alma', valor: '3.200 USD' },
  { emoji: '📌', concepto: 'Separación', valor: '333 USD' },
]
